import './style'
import Bootstrap from './Bootstrap'
import { Provider } from 'preact-redux'
import store from './store'

const AppContainer = () => {
  return (
    <Provider store={store}>
      <Bootstrap />
    </Provider>
  )
}
export default AppContainer



// WEBPACK FOOTER //
// ./index.js